(() => {
  const quote = (value) => `"${String(value).replace(/"/g, '').trim()}"`;

  document.querySelectorAll('[data-rsp-vehicle-finder]').forEach((form) => {
    const error = form.querySelector('[data-rsp-finder-error]');
    form.querySelectorAll('input:not([type="hidden"]), select').forEach((field) => {
      field.addEventListener('input', () => { if (error) error.hidden = true; });
      field.addEventListener('change', () => { if (error) error.hidden = true; });
    });
    form.addEventListener('submit', (event) => {
      const year = form.querySelector('[data-rsp-finder-year]')?.value?.trim();
      const keyword = form.querySelector('[data-rsp-finder-keyword]')?.value?.trim();
      const make = form.querySelector('[data-rsp-finder-make]')?.value?.trim();
      const model = form.querySelector('[data-rsp-finder-model]')?.value?.trim();
      const category = form.querySelector('[data-rsp-finder-category]')?.value?.trim();
      const values = [keyword, year, make, model, category].filter(Boolean);
      if (!values.length) {
        event.preventDefault();
        error?.removeAttribute('hidden');
        form.querySelector('input, select')?.focus();
        return;
      }
      if (error) error.hidden = true;
      const vehicle = [year, make, model].filter(Boolean);
      const terms = [];
      if (keyword) terms.push(keyword);
      if (vehicle.length === 3) terms.push(quote(vehicle.join(' ')));
      else terms.push(...vehicle.map(quote));
      if (category) terms.push(quote(category));
      form.querySelector('[data-rsp-finder-query]').value = terms.join(' AND ');
      try {
        window.Shopify?.analytics?.publish('roadspec_vehicle_search', { fields_used: values.length });
      } catch (_) {}
    });
  });
})();
